var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2508 15.5C15.665 15.5 16.0008 15.8358 16.0008 16.25C16.0008 16.6642 15.665 17 15.2508 17H4.75083C4.33662 17 4.00083 16.6642 4.00083 16.25C4.00083 15.8358 4.33662 15.5 4.75083 15.5H15.2508ZM12.0008 3C12.5531 3 13.0008 3.44772 13.0008 4V9H15.5008C15.9813 9.00001 16.185 9.61209 15.8006 9.90039L10.6004 13.7998C10.245 14.0663 9.75671 14.0663 9.40122 13.7998L4.20103 9.90039C3.81662 9.61209 4.02033 9 4.50083 9H7.00083V4C7.00083 3.44772 7.44855 3 8.00083 3H12.0008Z",
    fill: "#4785FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload);
export default __webpack_public_path__ + "static/media/ic_download.217d464048eb2394ecbe77ac66fc35ff.svg";
export { ForwardRef as ReactComponent };